<template>
  <v-container fluid
               v-if="template">
    <PageTitle>
      {{ template.name }}
      <template v-slot:buttons>
        <v-btn title="Reload template"
               :disabled="loading"
               @click.prevent="fetchData">
          Refresh
        </v-btn>
      </template>
    </PageTitle>

    <v-card class="mb-4">
      <v-card-title>
        Subject: {{ template.subject }}
      </v-card-title>
    </v-card>

    <template v-if="userMetrics">
      <v-row>
        <v-col cols="6"
               sm="4">
          <MetricCard title="Delivered"
                      :count="userMetrics.delivered_count"
                      :rate="Number(userMetrics.delivered_rate)">
          </MetricCard>
        </v-col>

        <v-col cols="6"
               sm="4">
          <MetricCard title="Opened"
                      :count="userMetrics.unique_open_count"
                      :rate="Number(userMetrics.open_rate)">
          </MetricCard>
        </v-col>

        <v-col cols="6"
               sm="4">
          <MetricCard title="Clicked"
                      :count="userMetrics.unique_click_count"
                      :rate="Number(userMetrics.click_rate)">
          </MetricCard>
        </v-col>
      </v-row>

      <v-row>
        <v-col cols="12"
               sm="4">
          <MetricCard title="Unsubscribes"
                      :count="userMetrics.unique_unsubscribe_count"
                      :rate="Number(userMetrics.unsubscribe_rate)">
          </MetricCard>
        </v-col>

        <v-col cols="12"
               sm="4">
          <MetricCard title="Spam Complaints"
                      :count="userMetrics.unique_complaint_count"
                      :rate="Number(userMetrics.complaint_rate)">
          </MetricCard>
        </v-col>

        <v-col cols="12"
               sm="4">
          <MetricCard title="Hard Fails"
                      :count="userMetrics.unique_failed_count"
                      :rate="Number(userMetrics.failed_rate)">
          </MetricCard>
        </v-col>
      </v-row>
    </template>

    <v-row>
      <v-col cols="12">
        <ShareTemplateDailyMetricsChart :template="template"
                                        :start="form.start"
                                        :end="form.end"
                                        :sender="user">
          <template v-slot:title>
            Email activity in the past 30 days
          </template>
        </ShareTemplateDailyMetricsChart>
      </v-col>
    </v-row>

    <v-row v-if="template.is_campaign">
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Campaign Activity
            <v-spacer></v-spacer>
            <v-text-field v-model="campaignSearch"
                          append-icon="fal fa-search"
                          small
                          label="Search"
                          single-line
                          hide-details
                          class="pt-0">
            </v-text-field>
            <v-btn icon
                   small
                   class="ml-4"
                   @click.prevent="exportCampaigns">
              <v-icon>
                fal fa-fw fa-download
              </v-icon>
            </v-btn>
          </v-card-title>
          <campaigns-table :loading="loading"
                           :campaigns="campaigns"
                           :search="campaignSearch">
          </campaigns-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Emails
            <v-spacer></v-spacer>
            <v-text-field v-model="messageSearch"
                          append-icon="fal fa-search"
                          small
                          label="Search"
                          single-line
                          hide-details
                          class="pt-0">
            </v-text-field>
            <v-btn icon
                   small
                   class="ml-4"
                   @click.prevent="exportMessages">
              <v-icon>
                fal fa-fw fa-download
              </v-icon>
            </v-btn>
            <help-dialog v-if="1===2"
                         icon>
            </help-dialog>
          </v-card-title>
          <v-data-table dense
                        :headers="messageHeaders"
                        :items="messages"
                        :items-per-page="5"
                        :loading="loading"
                        :search="messageSearch">
            <template v-slot:item.recipient="{item: message}">
              {{ message.recipient }}
            </template>
            <template v-slot:item.created_at="{item: message}">
              <message-link :message="message"
                            :use-dialog="true">
              </message-link>
            </template>
            <template v-slot:item.delivered_at="{item:message}">
              <date-tool-tip :date="message.delivered_at">
              </date-tool-tip>
            </template>
            <template v-slot:item.opened_at="{item:message}">
              <date-tool-tip :date="message.opened_at">
              </date-tool-tip>
            </template>
            <template v-slot:item.clicked_at="{item:message}">
              <date-tool-tip :date="message.clicked_at">
              </date-tool-tip>
            </template>
            <template v-slot:item.failed_at="{item:message}">
              <date-tool-tip :date="message.failed_at">
              </date-tool-tip>
            </template>
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

    <v-row>
      <v-col cols="12">
        <v-card>
          <v-card-title>
            Link Activity
            <v-spacer></v-spacer>
            <v-text-field v-model="linkSearch"
                          append-icon="fal fa-search"
                          small
                          label="Search"
                          single-line
                          hide-details
                          class="pt-0">
            </v-text-field>
            <v-btn icon
                   small
                   class="ml-4">
              <v-icon>
                fal fa-fw fa-download
              </v-icon>
            </v-btn>
            <help-dialog v-if="1===2"
                         icon>
            </help-dialog>
          </v-card-title>
          <v-data-table dense
                        :headers="linkHeaders"
                        :items="links"
                        :items-per-page="5"
                        :loading="loading"
                        :search="linkSearch">
          </v-data-table>
        </v-card>
      </v-col>
    </v-row>

  </v-container>
</template>
<script>
import {mapGetters} from 'vuex';
import {orderBy} from 'lodash';
import {Form} from 'vform';
import shareTemplateService from '../../../../../ml/services/shareTemplateService';
import mailcoachService from '../../../services/mailcoachService';
import CampaignsTable from '../../mailcoach/components/CampaignsTable';
import HelpDialog from '../../../components/HelpDialog';
import mailgunService from '../../../../../ml/services/mailgunService';
import MessageLink from '../../mailgun/components/MessageLink';
import DateToolTip from '../../../components/DateToolTip';
import MetricCard from '../../../components/MetricCard.vue';
import PageTitle from '../../../components/PageTitle.vue';
import ShareTemplateDailyMetricsChart from '../../mailgun/components/ShareTemplateDailyMetricsChart.vue';
import moment from 'moment-timezone';

export default {
  components: {ShareTemplateDailyMetricsChart, PageTitle, MetricCard, DateToolTip, MessageLink, HelpDialog, CampaignsTable},
  data() {
    return {
      campaigns: [],
      campaignSearch: null,
      form: new Form({
        start: moment().subtract(30, 'days').format('YYYY-MM-DD'),
        end: moment().format('YYYY-MM-DD'),
        sender_id: null,
      }),
      messages: [],
      messageHeaders: [
        {
          text: 'Created',
          value: 'created_at',
        },
        /*{
          text: 'Sender',
          value: 'sender.name',
        },*/
        {
          text: 'Recipient',
          value: 'recipient',
        },
        {
          text: 'Status',
          value: 'status',
        },
        {
          text: 'Delivered',
          value: 'delivered_at',
        },
        {
          text: 'Opened',
          value: 'opened_at',
        },
        {
          text: 'Clicked',
          value: 'clicked_at',
        },
        {
          text: 'Failed',
          value: 'failed_at',
        },
      ],
      messageSearch: null,
      timeSeriesData: [],
      linkHeaders: [
        {
          text: 'Link',
          value: 'url',
        },
        {
          text: 'Unique clicks',
          value: 'unique_click_count',
        },
        {
          text: 'Total clicks',
          value: 'click_count',
        },
      ],
      links: [],
      linkSearch: null,
      loading: false,
      template: null,
    }
  },
  computed: {
    ...mapGetters([
      'team',
      'user',
    ]),
    templateID() {
      return parseInt(this.$route.params.templateID);
    },
    userMetrics() {
      return this.template.user_metrics;
    },
  },
  created() {
    this.form.sender_id = this.user.id;
    this.fetchData();
  },
  methods: {
    async fetchData() {
      if (this.loading) {
        return;
      }
      this.loading = true;
      return Promise.all([
        this.getTemplate(),
        this.getCampaigns(),
        this.getLinks(),
        this.getMessages(),
      ])
        .catch(err => {
          console.log('fetchData error', err.message);
        })
        .finally(() => {
          this.loading = false;
        })
    },
    getTemplate() {
      return shareTemplateService.getTemplate(this.templateID, this.form.sender_id)
        .then(data => {
          this.template = data;
        })
    },
    getLinks() {
      return shareTemplateService.getLinks(this.templateID, {sender_id: this.form.sender_id})
        .then(data => {
          this.links = orderBy(data, ['click_count', 'unique_click_count', 'url'], ['desc', 'desc', 'asc']);
        })
    },
    getCampaigns() {
      const form = {
        share_template_id: this.templateID,
        user_id: this.form.sender_id,
      };
      return mailcoachService.getCampaigns(form)
        .then(data => {
          this.campaigns = orderBy(data, ['created_at'], ['desc']);
        });
    },
    getMessages() {
      const form = {
        order_by: 'created_at',
        order_dir: 'desc',
        page: 1,
        per_page: 100,
        sender_id: this.form.sender_id,
        share_template_id: this.templateID,
      };
      return mailgunService.getMessages(form)
        .then(data => {
          this.messages = orderBy(data.data, ['created_at'], ['desc']);
        })
    },
    exportCampaigns() {
      const form = {
        share_template_id: this.template.id,
      }
      const filename = `${this.template.name} - campaigns.csv`
      return mailcoachService.exportCampaigns(form, filename);
    },
    exportMessages() {
      const form = {
        share_template_id: this.template.id,
        export: 1,
      }
      const filename = `${this.template.name} - emails.csv`;
      return mailgunService.exportMessages(form, filename);
    },
  },
}
</script>
